import React, { type FC } from 'react';
import { styled } from 'styled-components';

import { colors } from 'src/css/theme';
import { GOODCANNA_STATUS_DENIED, GOODCANNA_STATUS_PENDING } from 'src/utils/helpers/goodcanna-status';

type MedCertVariant = 'pending' | 'denied';

type MedCertCheckoutBannerProps = {
  normalizedStatus?: string;
};

export const MedCertCheckoutBanner: FC<MedCertCheckoutBannerProps> = ({ normalizedStatus }) => {
  const variant: MedCertVariant = normalizedStatus === GOODCANNA_STATUS_DENIED ? 'denied' : 'pending';

  const pendingCopy = (
    <p>
      <strong>Med certification required for checkout.</strong> Customer profile will update automatically after
      they&apos;re consulted and approved.
    </p>
  );

  const deniedCopy = (
    <p>
      <strong>Medical certification denied.</strong> Manually update customer profile or have customer re-apply for a new
      certification.
    </p>
  );

  return (
    <Banner $variant={variant} data-testid='med-cert-checkout-banner'>
      {normalizedStatus === GOODCANNA_STATUS_PENDING && pendingCopy}
      {normalizedStatus === GOODCANNA_STATUS_DENIED && deniedCopy}
    </Banner>
  );
};

const Banner = styled.div<{ $variant: MedCertVariant }>`
  font-family: Lato, Matter, sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 1rem 1.25rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  border: 1px solid
    ${({ $variant }) => ($variant === 'denied' ? '#fecaca' : '#e8d4c4')};
  background: ${({ $variant }) => ($variant === 'denied' ? '#fef2f2' : '#fff8f0')};
  color: ${({ $variant }) => ($variant === 'denied' ? '#991b1b' : colors.dutchie.almostBlack)};

  p {
    margin: 0;
  }

  strong {
    color: ${({ $variant }) => ($variant === 'denied' ? '#7f1d1d' : colors.dutchie.gunmetal)};
    font-weight: 700;
  }
`;
